import React, { useState } from "react";
import { toast } from "sonner";
import { ListChecks, PaperPlaneTilt } from "@phosphor-icons/react";
import api from "@/lib/api";
import { targetDisplay } from "@/components/delivery/destinationHelpers";
import { SetupInstructionsButton } from "@/components/delivery/SetupInstructionsButton";
import { LeadShareDialog } from "@/components/pageSettings/LeadShareDialog";
import { BTN_BLACK, BTN_WHITE, errText } from "@/components/pageSettings/AdminModal";
import { setupUrl } from "./StepShell";

function TestBadge({ t }) {
  const [txt, cls] = !t ? ["Not tested yet", "bg-zinc-200"]
    : t.stale ? ["Changed since last test", "bg-amber-200"]
      : t.ok ? [`Passed ${new Date(t.created_at).toLocaleString()}`, "bg-emerald-600 text-white"]
        : ["Last test failed", "bg-red-600 text-white"];
  return <span className={`px-2 py-0.5 text-[10px] uppercase tracking-widest border-2 border-black ${cls}`} data-testid="setup-test-status">{txt}</span>;
}

export function DeliveryTest({ state, orgId, onSaved }) {
  const t = state.test;
  const d = state.delivery;
  const [busy, setBusy] = useState(false);
  const [fields, setFields] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`${setupUrl(orgId)}/test`);
      onSaved(data);
      if (data.test?.ok) toast.success("Test lead reached their system");
      else toast.error("The test lead didn't go through");
    } catch (e) {
      toast.error(errText(e, "Couldn't send the test"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="border-t-2 border-black pt-5 space-y-3" data-testid="setup-delivery-test">
      <div className="flex items-center gap-2 flex-wrap">
        <div className="label-mono">Test the delivery (required)</div>
        <TestBadge t={t} />
      </div>
      <p className="text-[11px] text-zinc-600">
        Sends one made-up lead marked TEST to <span className="font-mono break-all">{targetDisplay(d)}</span>, with every field they will get.
      </p>
      {t && !t.ok && (
        <div className="border-2 border-red-600 bg-red-50 p-2 text-[11px] font-mono break-all" data-testid="setup-test-detail">
          {t.code ? `Their system answered ${t.code}. ` : ""}{t.rejected_reason || t.response_body || "No reply"}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <button type="button" className={BTN_BLACK} onClick={run} disabled={busy} data-testid="setup-test-send">
          <PaperPlaneTilt size={11} weight="bold" /> {busy ? "Sending…" : t ? "Send another test" : "Send test lead"}
        </button>
        <button type="button" className={BTN_WHITE} onClick={() => setFields(true)} data-testid="setup-fields-sent">
          <ListChecks size={11} weight="bold" /> Fields they get
        </button>
        <SetupInstructionsButton destId={d.id} className={BTN_WHITE} testId="setup-instructions" />
      </div>
      {fields && <LeadShareDialog destId={d.id} title={`${state.org.name} — fields they get`} onClose={() => setFields(false)} />}
    </div>
  );
}
